import { buildInputTableCols, CellFieldV2, type InputTableCol } from '@/components/custom/erp';
import type { AccountConstraintRow } from '../../types';
import { Checkbox } from '@/components/ui/checkbox';

export const accountTypeOptions = [
  { value: 'KPL', label: 'KPL. Không phân loại' },
  { value: 'TA', label: 'TA. Thuế' },
  { value: 'TI', label: 'TI. Tiền' },
  { value: 'CN', label: 'CN. Công nợ' },
  { value: 'NH', label: 'NH. Ngân hàng' },
  { value: 'VV', label: 'VV. Vụ việc' },
  { value: 'HD', label: 'HD. Hợp đồng' },
  { value: 'KU', label: 'KU. Khế ước' },
  { value: 'MR1', label: 'MR1. Mở rộng 1' },
  { value: 'MR2', label: 'MR2. Mở rộng 2' }
];

export const getConstraintColumns = (
  mode: 'add' | 'edit' | 'view',
  onCellValueChange: (rowId: string, field: keyof AccountConstraintRow, value: unknown) => void
) => {
  const isViewMode = mode === 'view';

  const cols: InputTableCol<AccountConstraintRow>[] = [
    {
      field: 'objectName',
      headerName: 'Tên đối tượng',
      width: 280,
      valueGetter: row => row.objectName,
      renderCell: params => (
        <div className='w-full' onClick={event => event.stopPropagation()}>
          <CellFieldV2 name='objectName' type='text' value={params.row.objectName} disabled={true} />
        </div>
      )
    },
    {
      field: 'requireInput',
      headerName: 'Bắt buộc nhập',
      width: 140,
      align: 'center',
      headerAlign: 'center',
      valueGetter: row => row.requireInput,
      renderCell: params => (
        <div className='flex h-full w-full items-center justify-center' onClick={event => event.stopPropagation()}>
          {isViewMode ? (
            <Checkbox checked={Boolean(params.row.requireInput)} disabled className='size-4' />
          ) : (
            <Checkbox
              checked={Boolean(params.row.requireInput)}
              disabled={!params.row.uuid}
              className='size-4'
              onCheckedChange={value => onCellValueChange(params.row.id, 'requireInput', value)}
            />
          )}
        </div>
      )
    }
  ];

  return buildInputTableCols(cols);
};
